import React, { useState } from "react";
import { buildCrossSignals } from "helpers/dashboard/buildCrossSignals";

const PRIORITY_LABEL = {
  critical: "Urgent",
  high: "High",
  medium: "Medium",
  low: "Low",
};

const INITIAL_VISIBLE = 5;

const ActionPlan = ({ recommendations, capacity }) => {
  const items = recommendations || [];
  const crossSignals = buildCrossSignals(capacity?.classDemand || []);
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? items : items.slice(0, INITIAL_VISIBLE);

  return (
    <section className="owner-dashboard__panel owner-dashboard__panel--actions">
      <div className="owner-dashboard__panel-header">
        <div>
          <h2 className="owner-dashboard__panel-title">What to do next</h2>
          <p className="owner-dashboard__panel-subtitle">
            Enrollment and capacity — ranked by impact from your live schedule.
          </p>
        </div>
      </div>

      {crossSignals.length > 0 && (
        <div className="owner-dashboard__signal-highlight">
          <h3 className="owner-dashboard__signal-highlight-title">
            Schedule + website agree
          </h3>
          <ul className="owner-dashboard__signal-highlight-list">
            {crossSignals.map((signal) => (
              <li
                key={signal.key}
                className={`owner-dashboard__signal-highlight-item owner-dashboard__signal-highlight-item--${signal.tone}`}
              >
                {signal.text}
              </li>
            ))}
          </ul>
        </div>
      )}

      {items.length === 0 ? (
        <div className="owner-dashboard__empty-state">
          No urgent actions right now. Schedules look balanced — check back after
          the next registration push.
        </div>
      ) : (
        <ol className="owner-dashboard__action-list">
          {visible.map((item, index) => (
            <li
              key={item.id}
              className={`owner-dashboard__action-item owner-dashboard__action-item--${item.priority}`}
            >
              <span className="owner-dashboard__action-rank" aria-hidden="true">
                {index + 1}
              </span>
              <div className="owner-dashboard__action-body">
                <div className="owner-dashboard__action-meta">
                  <span
                    className={`owner-dashboard__priority-badge owner-dashboard__priority-badge--${item.priority}`}
                  >
                    {PRIORITY_LABEL[item.priority] || item.priority}
                  </span>
                  {item.category && (
                    <span className="owner-dashboard__action-category">
                      {item.category}
                    </span>
                  )}
                </div>

                <h3 className="owner-dashboard__action-title">{item.title}</h3>

                {item.detail && (
                  <p className="owner-dashboard__action-detail">{item.detail}</p>
                )}

                {item.evidence?.length > 0 && (
                  <div className="owner-dashboard__action-tags">
                    {item.evidence.map((line, evidenceIndex) => (
                      <span
                        key={`${item.id}-evidence-${evidenceIndex}`}
                        className="owner-dashboard__action-tag"
                      >
                        {line}
                      </span>
                    ))}
                  </div>
                )}

                <p className="owner-dashboard__action-step">
                  <strong>Next step:</strong> {item.action}
                </p>
              </div>
            </li>
          ))}
        </ol>
      )}

      {items.length > INITIAL_VISIBLE && (
        <button
          type="button"
          className="owner-dashboard__text-btn"
          onClick={() => setShowAll((value) => !value)}
        >
          {showAll
            ? "Show fewer"
            : `Show ${items.length - INITIAL_VISIBLE} more`}
        </button>
      )}
    </section>
  );
};

export default ActionPlan;
